import { useRef, useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Paperclip, X, Loader2, FileText, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function ForumAttach({ value = [], onChange }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);
  const [maxMb, setMaxMb] = useState(10);

  useEffect(() => {
    api.get("/upload-settings").then((r) => setMaxMb(r.data.max_file_mb || 10)).catch(() => {});
  }, []);

  const handleFiles = async (files) => {
    setUploading(true);
    try {
      const added = [];
      for (const file of Array.from(files)) {
        if (file.size > maxMb * 1024 * 1024) {
          toast.error(`Plik „${file.name}" jest za duży (maks. ${maxMb} MB)`);
          continue;
        }
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/forum/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        added.push(data);
      }
      if (added.length) onChange([...value, ...added]);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Błąd przesyłania pliku");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (path) => onChange(value.filter((a) => a.path !== path));

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="outline" size="sm" onClick={() => inputRef.current?.click()} disabled={uploading} className="gap-1.5" data-testid="forum-attach-button">
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paperclip className="h-4 w-4" />}
          Załącz plik
        </Button>
        <span className="text-xs text-muted-foreground">Obrazy i PDF, maks. {maxMb} MB</span>
      </div>
      {value.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {value.map((a) => (
            <div key={a.path} className="flex items-center gap-1.5 rounded-lg border border-border bg-secondary px-2.5 py-1.5 text-xs" data-testid={`forum-attach-item`}>
              {a.content_type === "application/pdf" ? <FileText className="h-3.5 w-3.5 text-ztk-red" /> : <ImageIcon className="h-3.5 w-3.5 text-ztk-blue" />}
              <span className="max-w-[140px] truncate">{a.filename}</span>
              <button type="button" onClick={() => remove(a.path)} className="text-muted-foreground hover:text-destructive"><X className="h-3.5 w-3.5" /></button>
            </div>
          ))}
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/*,application/pdf" multiple className="hidden" onChange={(e) => e.target.files.length && handleFiles(e.target.files)} data-testid="forum-attach-input" />
    </div>
  );
}
